/**
 * @license
 * @preserve
 *
 * KeeeX SAS Confidential
 * https://keeex.me
 * Copyright 2013-2020 KeeeX All Rights Reserved.
 * 
 * These computer program listings and specifications, herein,
 * are and remain the property of KeeeX SAS. The intellectual
 * and technical concepts herein are proprietary to KeeeX SAS
 * and may be covered by EU and foreign patents,
 * patents in process, trade secrets and copyright law.
 * 
 * They shall not be reproduced or copied or used in whole or
 * in part as the basis for manufacture or sale of items unless
 * prior written permission is obtained from KeeeX SAS.
 * 
 * For a license agreement, please contact:
 * <mailto: contact@keeex.net>
 * 
 */
const t=(t,n,e)=>new DataView(t instanceof Uint8Array?t.buffer:t,t instanceof Uint8Array?t.byteOffset+n:n,e);export const readInt32LE=(n,e)=>t(n,e,4).getInt32(0,!0);export const readUint32LE=(n,e)=>t(n,e,4).getUint32(0,!0);export const readUint32BE=(n,e)=>t(n,e,4).getUint32(0,!1);export const writeUint32LE=(n,e,r)=>t(n,e,4).setUint32(0,r,!0);export const writeInt32LE=(n,e,r)=>t(n,e,4).setInt32(0,r,!0);export const writeUint32BE=(n,e,r)=>t(n,e,4).setUint32(0,r,!1);